var map = {
	"./track1.webp": 1956,
	"./track10.webp": 3444,
	"./track11.webp": 9687,
	"./track12.webp": 9254,
	"./track13.webp": 4577,
	"./track2.webp": 6481,
	"./track3.webp": 6726,
	"./track4.webp": 5451,
	"./track5.webp": 1208,
	"./track6.webp": 6165,
	"./track7.webp": 2810,
	"./track8.webp": 6447,
	"./track9.webp": 4908
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3099;